module.exports = __webpack_public_path__ + "static/media/watch_nav_hermes.400c9379.svg";